import UserSearchResultListing from './UserSearchResultListing';

export default UserSearchResultListing;
